// useApiProxy.js - Hook simplifié
import { useState, useCallback } from 'react';
import { getApiHeaders, getApiUrl } from '../config/proxyConfig';

export const useApiProxy = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchApi = useCallback(async (endpoint, options = {}) => {
    try {
      setLoading(true);
      setError(null);

      const url = getApiUrl(endpoint);
      const headers = {
        ...getApiHeaders(),
        ...options.headers
      };

      console.log(`🔄 Appel API: ${url}`);

      const response = await fetch(url, {
        method: options.method || 'GET',
        headers,
        body: options.body ? JSON.stringify(options.body) : undefined
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;

    } catch (err) {
      console.error('❌ Erreur API:', err);
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    fetchApi
  };
};